import { render, staticRenderFns } from "./UserBox.vue?vue&type=template&id=62b124b6&scoped=true"
import script from "./UserBox.vue?vue&type=script&lang=js"
export * from "./UserBox.vue?vue&type=script&lang=js"
import style0 from "./UserBox.vue?vue&type=style&index=0&id=62b124b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b124b6",
  null
  
)

export default component.exports